// Canonical id types per docs/06_DATA_MODEL.md.
//
// EntityId is unique across all entity tables (squads, cores, controlNodes, ...). Allocate
// new ids only through `nextEntityId` so collisions cannot happen.

export type PlayerId = 0 | 1;
export type EntityId = number & { readonly __brand: 'EntityId' };
export type Tick = number & { readonly __brand: 'Tick' };

export const PLAYER_ZERO: PlayerId = 0;
export const PLAYER_ONE: PlayerId = 1;

export function entityId(raw: number): EntityId {
  return raw as EntityId;
}

export function tickOf(raw: number): Tick {
  return raw as Tick;
}

export function nextEntityId(state: { nextEntityId: number }): EntityId {
  const id = state.nextEntityId;
  state.nextEntityId = id + 1;
  return id as EntityId;
}

export function otherPlayer(p: PlayerId): PlayerId {
  return p === 0 ? 1 : 0;
}
